import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {EMPTY_CONTACT} from '@models/empty';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    constructor(public cityService: CityService, public adService: AdService, public commonService: CommonService) {

    }

    ngOnInit() {
        this.favorite = this.adService.updateValues(this.favorite);
    }

    edit(event, fields = '') {
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    addContact() {
        let contact = Object.assign({}, EMPTY_CONTACT);

        this.favorite.contacts.push(contact);
        this.favoriteChange.emit();
    }


    duplicateContact(i) {
        let contact = Object.assign({}, this.favorite.contacts[i]);

        this.favorite.contacts.push(contact);
        this.favoriteChange.emit();
    }

    deleteContact(i) {
        this.favorite.contacts.splice(i, 1);
        this.favoriteChange.emit();
    }
}
